import React, { useState, useEffect } from 'react';
import { Card, Button, Table, Form, Modal } from 'react-bootstrap';
import axiosInstance from '../../utils/axiosConfig';
import { toast } from 'react-toastify';

interface KatPlaniSablonu {
    id: number;
    sablonAdi: string;
    aciklama: string;
    katSayisi: number;
    olusturmaTarihi: string;
}

const KatPlaniSablonlari: React.FC = () => {
    const [sablonlar, setSablonlar] = useState<KatPlaniSablonu[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [yeniSablon, setYeniSablon] = useState({
        sablonAdi: '',
        aciklama: '',
        katSayisi: 0
    });

    // Şablonları getir
    const fetchSablonlar = async () => {
        try {
            const response = await axiosInstance.get('/api/KatPlaniSablonlari');
            setSablonlar(response.data);
        } catch (error) {
            toast.error('Şablonlar yüklenirken bir hata oluştu.');
            console.error('Şablonlar yüklenirken hata:', error);
        }
    };

    useEffect(() => {
        fetchSablonlar();
    }, []);

    const handleModalClose = () => {
        setShowModal(false);
        setYeniSablon({
            sablonAdi: '',
            aciklama: '',
            katSayisi: 0
        });
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setYeniSablon(prev => ({
            ...prev,
            [name]: name === 'katSayisi' ? parseInt(value) || 0 : value
        }));
    };

    const handleSablonKaydet = async () => {
        try {
            await axiosInstance.post('/api/KatPlaniSablonlari', yeniSablon);
            toast.success('Şablon başarıyla kaydedildi.');
            handleModalClose();
            fetchSablonlar();
        } catch (error) {
            toast.error('Şablon kaydedilirken bir hata oluştu.');
            console.error('Şablon kaydedilirken hata:', error);
        }
    };

    const handleSablonSil = async (id: number) => {
        if (window.confirm('Bu şablonu silmek istediğinize emin misiniz?')) {
            try {
                await axiosInstance.delete(`/api/KatPlaniSablonlari/${id}`);
                toast.success('Şablon başarıyla silindi.');
                fetchSablonlar();
            } catch (error) {
                toast.error('Şablon silinirken bir hata oluştu.');
                console.error('Şablon silinirken hata:', error);
            }
        }
    };

    return (
        <div className="container-fluid">
            <div className="row mb-2">
                <div className="col-sm-6">
                    <h1>Kat Planı Şablonları</h1>
                </div>
                <div className="col-sm-6">
                    <Button 
                        className="float-right"
                        variant="primary"
                        onClick={() => setShowModal(true)}
                    >
                        <i className="fas fa-plus"></i> Yeni Şablon
                    </Button>
                </div>
            </div>

            <Card>
                <Card.Body>
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>Şablon Adı</th>
                                <th>Açıklama</th>
                                <th>Kat Sayısı</th>
                                <th>Oluşturma Tarihi</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sablonlar.map((sablon) => (
                                <tr key={sablon.id}>
                                    <td>{sablon.sablonAdi}</td>
                                    <td>{sablon.aciklama}</td>
                                    <td>{sablon.katSayisi}</td>
                                    <td>{new Date(sablon.olusturmaTarihi).toLocaleDateString('tr-TR')}</td>
                                    <td>
                                        <Button
                                            variant="info"
                                            size="sm"
                                            className="mr-2"
                                            title="Düzenle"
                                        >
                                            <i className="fas fa-edit"></i>
                                        </Button>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => handleSablonSil(sablon.id)}
                                            title="Sil"
                                        >
                                            <i className="fas fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Yeni Şablon Ekleme Modal */}
            <Modal show={showModal} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Yeni Kat Planı Şablonu</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Şablon Adı</Form.Label>
                            <Form.Control
                                type="text"
                                name="sablonAdi"
                                value={yeniSablon.sablonAdi}
                                onChange={handleInputChange}
                                placeholder="Şablon adını giriniz"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Açıklama</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="aciklama"
                                value={yeniSablon.aciklama}
                                onChange={handleInputChange}
                                placeholder="Şablon açıklamasını giriniz"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Kat Sayısı</Form.Label>
                            <Form.Control
                                type="number"
                                name="katSayisi"
                                value={yeniSablon.katSayisi}
                                onChange={handleInputChange}
                                min="1"
                                placeholder="Kat sayısını giriniz"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                        İptal
                    </Button>
                    <Button variant="primary" onClick={handleSablonKaydet}>
                        Kaydet
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default KatPlaniSablonlari;